












import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  name: 'UsersManagement',

  setup() {
    const activeTab = ref(0);

    function onTabChange(tab: number) {
      activeTab.value = tab;
    }

    return {
      activeTab,
      onTabChange,
    };
  },
});
